import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as homeActions from '../home/redux/actions';
import * as projectOnBoardActions from '../project-on-board/redux/actions';
import { drapcodeIcon, iconForField } from '../../common/custom/icon-library';
import * as Yup from 'yup';
import CustomRadio from '../../common/ui/CustomRadio';
import TooltipInfo from '../../common/docs/TooltipInfo';
import { showAlertHtml } from '../../common/utils/alert';
import { notAllowedWord, reservedValues } from '../../common/formElements/reservedKeywords';
import CustomSelect from '../../common/formElements/CustomSelect';
import { dynamicSort } from '../../common/utils/api_utils';
import { createEventsDescription, typeDescription } from '../../common/utils/validate';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
export class CreateCollection extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    creationFailedMsg: '',
    isPersistent: true,
    collectionCloneWith: 'collection_snapshot',
    restoreFrom: '',
    isCreateEvents: true,
  };
  componentDidMount = () => {
    const { actions } = this.props;
    const { projectId, version } = this.props;
    actions.loadCollectionSnapshots({ projectId, version });
  };

  handleFormSubmit = async (values) => {
    const { projectId, version, actions, homeActions, home, history } = this.props;
    const { selected } = this.props;
    const { restoreFrom, isPersistent, isCreateEvents } = this.state;
    const data = {
      collectionTitle: values.collectionTitle,
      willPersist: isPersistent,
      collectionIndex: values.collectionIndex,
      restoreFrom: restoreFrom,
      projectId,
      version,
      isCreateEvents,
      description: values.description,
    };
    const createCollectionResponse = await actions.createCollection(data);
    if (createCollectionResponse && createCollectionResponse.uuid) {
      homeActions.loadEditorCollections({ projectId, version });
      //on first collection create update project status
      if (home && home.collections.length === 0) {
        projectOnBoardActions.changeProjectStatus({
          state: 'COLLECTION_CREATED',
          status: 'COMPLETE',
          projectId,
          version,
        });
      }
      // handling redirect for snapshot case
      let redirectPath;
      if (selected) {
        redirectPath = `/collections/${version}/v/${projectId}`;
      } else {
        redirectPath = `/collections/${version}/v/${projectId}/fields/${createCollectionResponse.uuid}`;
      }
      history.push(redirectPath);
      return;
    }

    this.setState({
      creationFailedMsg: createCollectionResponse,
    });
  };
  handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    if (name === 'isCreateEvents') {
      const confirmationMsg = checked
        ? `When enabled, Save, Update, and Delete events will be automatically created with the collection.<br/><br/>Do you want to proceed?`
        : `Disabling this will prevent automatic creation of Save, Update, and Delete events for the collection.<br/><br/>Do you want to proceed?`;
      const preConfirm = () => {
        this.setState({ isCreateEvents: checked });
      };
      showAlertHtml(confirmationMsg, preConfirm, 'Proceed');
      return;
    }

    if (name === 'willPersist') {
      const confirmationMsg = checked
        ? `The DrapCode (default) database will be used to store and retrieve data.<br/><br/>Do you want to proceed?`
        : `Data will be fetched from an external source.<br/>Hence, you will <strong>not</strong> be able to store item data in the DrapCode (default) database.<br/><br/>Do you want to proceed?`;
      const preConfirm = () => {
        this.setState({ isPersistent: checked });
      };
      showAlertHtml(confirmationMsg, preConfirm, 'Proceed');
    } else {
      this.setState({ [name]: checked });
    }
  };
  prepareValidationForFields = () => {
    const { selected } = this.props;
    let validationSchema = {
      collectionTitle: Yup.string()
        .required("Collection Name can't be blank")
        .max(100, 'Name cannot be more than 100 characters')
        .matches(/^[A-Za-z\s]+$/, 'Name should not contain special characters or numbers')
        .test('reserved', 'This is a reserved word please use another', (value) => {
          const lowercaseValue = value ? value.toLowerCase() : '';
          return !reservedValues.includes(lowercaseValue);
        })
        .test('not-allowed', 'This type of word is not allowed.', (value) => {
          const lowercaseValue = value ? value.toLowerCase() : '';
          return !notAllowedWord.includes(lowercaseValue);
        }),
    };
    if (selected) {
      validationSchema.restoreFrom = Yup.string().required(
        'Please select a snapshot to create a collection',
      );
    }

    return Yup.object().shape(validationSchema);
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  showCollectionSnapshotsOptions = () => {
    const { restoreFrom } = this.state;
    const { selected } = this.props;
    if (selected) {
      return (
        <div className="form-group ml-3">
          <label style={{ marginBottom: '0px' }}>Copy Settings From Snapshot</label>

          <div className="d-flex align-items-center">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <i className={`wb ${iconForField('dropdown')}`}></i>
                <span className="required"> *</span>
              </span>
            </div>
            <div style={{ width: '100vw' }} className="ml-2">
              <CustomSelect
                name={'restoreFrom'}
                isMulti={false}
                onChange={setFieldValue}
                options={this.collectionSnapshotOptions()}
                value={restoreFrom}
              />

              <ErrorMessage name={'restoreFrom'} className="text-danger" />
            </div>
          </div>
        </div>
      );
    }
  };
  collectionSnapshotOptions = () => {
    let options = [{ value: '', label: '- Select Collection Snapshot -' }];
    const { collectionSnapshots } = this.props.collections;
    if (collectionSnapshots && collectionSnapshots.length > 0) {
      const sortedSnapshots = collectionSnapshots.sort(dynamicSort('createdAt')).reverse();
      options = options.concat(
        sortedSnapshots.map((snapshot) => ({
          value: snapshot.uuid,
          label: snapshot.name,
        })),
      );
    }

    return options;
  };

  //TODO: Refactor to use common Field
  render() {
    const { creationFailedMsg, isPersistent, restoreFrom, isCreateEvents } = this.state;
    const { selected } = this.props;
    return (
      <div className="card">
        <div className="card-header card-header-icon" data-background-color="drapcode-dark-blue">
          <i className={`wb ${drapcodeIcon('collection')}`}></i>
        </div>
        <div className="card-content">
          <div className="card-title-header">
            <h4 className="card-title">Create Collection</h4>
            <div className="card-cta"></div>
          </div>

          <Formik
            initialValues={{
              collectionTitle: '',
              collectionIndex: 1,
              willPersist: true,
              restoreFrom: '',
              isCreateEvents: true,
              description: '',
            }}
            validationSchema={this.prepareValidationForFields()}
            onSubmit={(values, { setSubmitting }) => {
              this.handleFormSubmit(values);
              setSubmitting(false);
            }}
          >
            {({ isSubmitting, setFieldValue, setFieldTouched, resetForm, errors }) => {
              return (
                <Form className="form-horizontal">
                  <div className="row mx-auto">
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <FormFieldWithLabel
                          cta={false}
                          label="Collection Name"
                          icon="text"
                          infoIcon={true}
                          isRequired={true}
                          infoDescription={
                            'Enter Collection Name of your choice. It should not contain special characters or numbers.'
                          }
                        >
                          <Field
                            type="text"
                            name="collectionTitle"
                            className="form-control form-control-sm"
                            placeholder="Collection Name"
                            title="Enter Collection Name"
                          />
                          <ErrorMessage
                            name="collectionTitle"
                            component="p"
                            className="text-danger"
                          />
                        </FormFieldWithLabel>
                      </div>
                      <div className="form-group">
                        <FormFieldWithLabel
                          cta={false}
                          label="Description (Optional)"
                          icon="text"
                          infoIcon={true}
                          infoDescription={'explains the purpose or usage of the collection.'}
                        >
                          <Field
                            type="text"
                            name="description"
                            className="form-control form-control-sm"
                            placeholder="Description For Collection"
                          />
                          <ErrorMessage name="description" component="p" className="text-danger" />
                        </FormFieldWithLabel>
                      </div>
                      <div className="form-group">
                        <div className="d-flex align-items-center">
                          <div className="mr-4">
                            <div className="input-group" title="Persistent Collection">
                              <div className="input-group-prepend">
                                <span className="input-group-text">
                                  <i className="wb webconnect-toggles"></i>
                                  <span className="required">*</span>
                                </span>
                              </div>
                              <div className="form-check">
                                <CustomRadio label="Persistent Collection" isRadio={false}>
                                  <input
                                    name="willPersist"
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={isPersistent}
                                    onChange={this.handleCheckboxChange}
                                  />
                                </CustomRadio>
                              </div>
                              <TooltipInfo
                                title={typeDescription}
                                headerText={`What's Persistent Collection?`}
                                showHeader={true}
                                showArrow={true}
                                append={true}
                              />
                            </div>
                          </div>
                          <div className="mr-4">
                            <div className="input-group" title="Create Events">
                              <div className="input-group-prepend">
                                <span className="input-group-text">
                                  <i className="wb webconnect-toggles"></i>
                                  {/* <span className="required">*</span> */}
                                </span>
                              </div>
                              <div className="form-check">
                                <CustomRadio label="Create Events" isRadio={false}>
                                  <input
                                    name="isCreateEvents"
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={isCreateEvents}
                                    onChange={this.handleCheckboxChange}
                                  />
                                </CustomRadio>
                              </div>
                              <TooltipInfo
                                title={createEventsDescription}
                                headerText={`What's Create Events?`}
                                showHeader={true}
                                showArrow={true}
                                append={true}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {selected && (
                        <div className="form-group ml-3">
                          <label style={{ marginBottom: '0px' }}>Copy Settings From Snapshot</label>
                          <div className="d-flex align-items-center">
                            <div className="input-group-prepend">
                              <span className="input-group-text">
                                <i className={`wb ${iconForField('dropdown')}`}></i>
                                <span className="required"> *</span>
                              </span>
                            </div>
                            <div style={{ width: '100vw' }} className="ml-2">
                              <CustomSelect
                                name={'restoreFrom'}
                                isMulti={false}
                                onChange={setFieldValue}
                                onChangeValue={(name, value) => {
                                  this.setState({ [name]: value });
                                }}
                                options={this.collectionSnapshotOptions()}
                                value={restoreFrom}
                              />
                              <p
                                style={{ marginTop: '0px', paddingLeft: '0px' }}
                                className="text-danger"
                              >
                                <ErrorMessage name={'restoreFrom'} />
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    {creationFailedMsg && (
                      <div className="error error-align">{creationFailedMsg}</div>
                    )}
                    <div className="col-md-12 col-lg-12 text-right">
                      <button className="btn btn-theme-submit btn-md" type="submit">
                        <i className="wb webconnect-plus"></i> Create
                      </button>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    homeActions: bindActionCreators({ ...homeActions }, dispatch),
    projectOnBoardActions: bindActionCreators({ ...projectOnBoardActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateCollection);
